<template>
  <div>
    <div class="image preview">
      <b-image class="preview__image" :src="previewImageUrl" ratio="1by1" />
    </div>
    <b-field label="プロフィール画像">
      <b-upload @input="inputImageFile" drag-drop expanded>
        <div class="content has-text-centered preview__upload">
          <p>
            <b-icon icon="upload" size="is-large"></b-icon>
          </p>
          <p>Drop your files here or click to upload</p>
        </div>
      </b-upload>
    </b-field>
  </div>
</template>

<script>

export default {
  name: 'RegistrationProfileImage',
  props: ['value'],
  computed: {
    photoFile: {
      get() {
        return this.value.photoFile;
      },
      set(photoFile) {
        this.updateValue({ photoFile });
      },
    },
    defaultPhotoUrl: {
      get() {
        return this.value.defaultPhotoUrl;
      }
    },
    previewImageUrl() {
      if (this.photoFile === null) return this.defaultPhotoUrl;
      return URL.createObjectURL(this.photoFile);
    }
  },
  methods: {
    updateValue(diff) {
      let newValue = {...this.value, ...diff};
      this.$emit('input', newValue);
    },
    inputImageFile(file) {
      this.photoFile = file;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/signup-email.scss';
</style>
